import { AgResourceLanguage } from '../types';
import { login as EnUsLogin } from '../en-us/login';

export const login: AgResourceLanguage['login'] = {
  ...EnUsLogin,
  header: 'Adresse e-mail ou mot de passe incorrect',
  description:
    'Assurez-vous qu’il s’agit de la même adresse e-mail que vous avez utilisée lors de votre commande ou de la création de votre compte.'
};
